import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {PartnerBreadcrumbComponent} from "./partner-breadcrumb.component";
import {DatetimeLabelModule} from "../../../../../core/component/date/datetime-label/datetime-label.module";
import {TablerIconsModule} from "angular-tabler-icons";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DatetimeLabelModule,
        TablerIconsModule,
    ],
    declarations: [
        PartnerBreadcrumbComponent,
    ],
    exports: [PartnerBreadcrumbComponent],
})
export class PartnerBreadcrumbModule {}